import React from 'react'
import clsx from 'clsx'

import CustomFieldTableRow, { CustomFieldTableRowProps } from '../Row'
import OverflowText from '@SonarCX/components/atoms/OverflowText'

import useStyles from './styles'

type TableProps = {
  fields: LocalCustomField[]
  rowsToRender: APIMeta[][]
} & Omit<CustomFieldTableRowProps, 'cells' | 'fields'>

const Table: React.FC<TableProps> = ({
  fields,
  rowsToRender,
  table,
  ...props
}) => {
  const sortedHeaders = React.useMemo(
    () =>
      table.options
        ? (table.options ?? [])
            .map(sortOrder => {
              return fields.find(newArrObject => {
                return newArrObject.id === sortOrder
              })
            })
            .filter(Boolean)
        : (table.config?.options ?? [])
            .map(sortOrder => {
              return fields.find(newArrObject => {
                return newArrObject.id === sortOrder.val
              })
            })
            .filter(Boolean),
    [table, fields]
  )

  const classes = useStyles()

  return (
    <table className={classes.root}>
      <thead>
        <tr className={clsx(classes.row, classes.separator, classes.headers)}>
          <td role='cell' className={classes.rowHeader} style={{ width: 36 }} />

          {sortedHeaders.map(field => (
            <td
              key={`${table.id}-${field.id}-${field.title}`}
              className={classes.rowHeader}
            >
              <OverflowText>{field.title}</OverflowText>
            </td>
          ))}
        </tr>
      </thead>

      <tbody>
        {rowsToRender.map((cells: APIMeta[], rowIndex: number) => (
          <CustomFieldTableRow
            key={`${table.id}-${rowIndex}`}
            table={table}
            cells={cells}
            fields={fields}
            {...props}
          />
        ))}
      </tbody>
    </table>
  )
}

export default Table
